export const SliderDirection = {
  Left: -1,
  Right: 1,
} as const;
export type SliderDirection =
  (typeof SliderDirection)[keyof typeof SliderDirection];
